export default "__VITE_PUBLIC_ASSET__936c1268__"